import CopyButton from "@/components/CopyButton";
import API from "@/constant/API";
import axiosInstance from "@/utils/axios";
import { getUrlParams } from "@/utils/utils";
import { Button, Stack, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DetailHeader from "../components/DetailHeader";
import RouteConstant from "@/constant/RouteConstant";
import classes from "@/pages/assets/css/index.module.less";
import AppLoadingButton from "@/components/mui/LoadingButton";

function DebtUnPaymentDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  
  useEffect(() => {
    const sn = getUrlParams('sn');
    if (sn) {
      _initData(sn);
    }
  }, []);

  const _initData = async (sn) => {
    const res = await axiosInstance.post(API.DEBT_UN_PAYMENT_DETAIL, {
      sn: sn
    });
    setData(res);
  }

  const _onLinkOrder = () => {
    // todo: 跳转到卡片消费流水详情
    // navigate({
    //   pathname: RouteConstant.,
      // search: createSearchParams({
      //   'cardId': data.cardId,
      //   'transactionId': data.transactionId,
      // }).toString()
    // })
  }

  const _onDeduct = () => {
    navigate(RouteConstant.DEBT_DETAILS);
  }

  if (!data) return null;

  return (
    <>
      <DetailHeader icon={''} title={data.businessTypeDisplayName} 
        titleIcon={''} amount={data.realDeductAmountUsd} currency={data.billCurrency} />
      
      {data.hasDeduct && <Button onClick={_onDeduct}>{t('deduct')}</Button>}

      {data.payList.map((item, idx) => <Stack key={idx} direction={'row'}>
        <div>{item.varietyCode}</div>
        <div>{item.amount}</div>
      </Stack>)}
      <Box className={classes['transaction-detail-wrap']}>
        <div className={'h4'}>{t('transaction_detail')}</div>
        <Stack>
          <div className={"small"}>{t('card_number')}</div>
          <div className={'text-primary'}>{data.cardNumber}</div>
        </Stack>
        <Stack>
          <div className={"small"}>{t('declined_transaction_fee')}</div>
          <div className={'text-primary'}>{data.transactionFee ?? '--'}</div>
        </Stack>
        <Stack>
          <div className={"small"}>{t('transaction_date')}</div>
          <div className={'text-primary'}>{data.transactionDate ?? '--'}</div>
        </Stack>
        <Stack>
          <div className={"small"}>{t('related_transaction_id')}</div>
          <div className={'text-primary'}>{data.relatedTransactionId ?? '--'}</div>
        </Stack>
        <Stack>
          <div className={"small"}>{t('transaction_id')}</div>
          <Stack direction={'row'} alignItems={'center'}>
            <span className={'text-primary'}>{data.sn}</span>
            <CopyButton value={data.sn} size={18}/>
          </Stack>
        </Stack>
        <AppLoadingButton variant="contained" size={"large"} fullWidth onClick={_onLinkOrder}>
          {t('view_linked_order')}
        </AppLoadingButton>
      </Box>

    </>
  )
}

export default DebtUnPaymentDetail
